import { addMonths, format } from 'date-fns'
import { getDateTime } from 'services/date-time'
/**
 * returns max delivery date in the default format for date input yyyy-mm-dd
 * @param {String|Date} date
 * @returns {String}
 */
export function getMaxDeliveryDate (date) {
  const isValidString = typeof date === 'string' && date.length > 0
  if (isValidString) {
    const startDate = getDateTime(date)
    const maxDate = addMonths(startDate, 6)
    return format(maxDate, 'YYYY-MM-DD')
  }

  return date
}

export default getMaxDeliveryDate
